import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { RunHistoryEntryGridComponent } from "../run-history-entry-grid/run-history-entry-grid.component";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-run-history-dialog",
  templateUrl: "./run-history-dialog.component.html",
  styleUrls: ["./run-history-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    RunHistoryEntryGridComponent,
    DialogHeaderComponent
  ]
})
export class RunHistoryDialogComponent implements OnInit {
  protected dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<RunHistoryDialogComponent>>(MatDialogRef);
  data = inject<{
    runHistory: RosterRunHistory;
  }>(MAT_DIALOG_DATA);

  ngOnInit() {
    console.log("dialog with data", this.data);
  }

  onClose() {
    this.dialogRef.close();
  }
}
